import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  CardActionArea,
  Grid,
  Container,
  Divider,
  Typography,
  TextField,
  IconButton,
  Alert,
  AlertTitle,
  CircularProgress,
  Paper,
  Tabs,
  Tab,
  CardActions,
  Button,
  Autocomplete
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import EditIcon from '@material-ui/icons/Edit';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup'; // eslint-disable-line
import moment from 'moment';
import { useSelector } from 'react-redux';
import Api from '../../utils/api';
import Diversos from '../../utils/diversos';
import UsuarioForm from '../../components/Usuario/UsuarioForm';

require('moment/locale/pt-br.js'); // eslint-disable-line

const UsuarioView = (props) => {
  const history = useNavigate();
  const api = new Api();
  const diversos = new Diversos();
  const auth = useSelector((state) => state.auth);
  const { id } = useParams();
  const [hasError, setHasError] = useState(false);
  const [hasSuccess, setHasSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingReg, setIsLoadingReg] = useState(true);
  const [reg, setReg] = useState(null);

  const get = async () => {
    setIsLoadingReg(true);

    try {
      const { data } = await api.get(`/users/${id}`, auth.token);

      setReg(data);
    } catch (e) {
      if (process.env.REACT_APP_ENVIROMENT !== 'development') {
        console.error(e);
      }
    } finally {
      setIsLoadingReg(false);
    }
  };

  const put = async () => {
    console.log('Nao faz nada apenas consulta');
  };

  useEffect(async () => {
    await Promise.all([get()]);
  }, []);

  if (isLoadingReg) {
    return (
      <>
        <Helmet>
          <title>{`Usuário - Consultar ${id} | ${process.env.REACT_APP_TITLE}`}</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 3
          }}
        >
          <Container maxWidth={false}>
            <Card>
              <CardHeader
                subheader="Usuário - Consultar"
                title={`Usuário: ${id}`}
                avatar={
                  <IconButton size="small" color="primary" onClick={() => history(-1)}>
                    <ArrowBackIcon />
                  </IconButton>
                }
              />
              <Divider />
              <Box sx={{ p: 5 }}>
                <Typography align="center" variant="h5" color="primary">
                  <CircularProgress color="primary" sx={{ mb: 3 }} />
                  <br />
                  Buscando informações, por favor aguarde...
                </Typography>
              </Box>
            </Card>
          </Container>
        </Box>
      </>
    );
  }

  return (
    <Formik
      initialValues={{
        ...reg
      }}
      onSubmit={put}
    >
      {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
        <UsuarioForm
          title={`Usuário - Consultar ${id}`}
          subtitle={values.USUARIO ? values.USUARIO : ''}
          errors={errors}
          handleBlur={handleBlur}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          touched={touched}
          values={values}
          setFieldValue={setFieldValue}
          isLoading={isLoading}
          hasError={hasError}
          hasSuccess={hasSuccess}
          fgConsultar
        />
      )}
    </Formik>
  );
};

export default UsuarioView;
